import React, { Component, useEffect, useState } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { PostApi } from "../../../js_assets/Network";
import axios from "axios";
import { api_url } from "../../../js_assets/ConfigApp";
import { GetApi } from "../../../js_assets/Network";
import CircularProgress from "@material-ui/core/CircularProgress";
import Schedule from "@material-ui/icons/Schedule";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import List from "@material-ui/core/List";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import { useForm, Controller } from "react-hook-form";
function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
    divider: {
        width: "100%",
    },
    ButtonGuide: {
        backgroundColor: "#74cbc4",
        color: "white",
        "&:hover": {
            background: "#74cbc4",
        },
        margin: theme.spacing.unit,
        padding: "5px",
        borderRadius: "5px",
        fontSize: 15,
        boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    iocns: {
        fontSize: 18,
    },
    canceliocn: {
        color: "black",
        float: "left",
    },
    p_followUp_Schedule_Description: {
        maxWidth: 270,
        lineHeight: "2.7em",
    },
    ButtonSubscription: {
        backgroundColor: "#74cbc4",
        color: "white",
        "&:hover": {
            background: "#74cbc4",
        },
        fontSize: 15,
        boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    btn_login: {
        color: "white",
        padding: "10px 1px",
        border: "none",
        cursor: "pointer",
        width: "100%",
        opacity: "0.9",
        borderRadius: "3px",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    tab: {
        flexGrow: 1,
        marginTop: -5,
        backgroundColor: "#f7faea",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    tab_button: {
        fontSize: 18,
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
});

function TrainerRow({
    data = [],
    handleOpen_DialogContent_trainer_Rating = () => { },
    redirectToUrl = () => { },
    openfollowUp_Schedule = () => { },
    opne_CV = () => { },
    handle_Open_DialogContentSubscriptionOffer = () => { },
    Delete_trainer = () => { },
    classes
}) {


    if (data.length == 0) return null


    return (
        data.reverse().map((trainer) => {
            return (
                <div>
                    <div
                        className="w3-cell-row"

                    >
                        <div className="w3-cell">
                            <img
                                className="w3-circle"
                                src={`${api_url}/Content/Profile_Images/${trainer.trainer_Image}`}
                            ></img>
                        </div>
                        <div className="w3-cell w3-container">
                            <h4>{trainer.trainer_Name}</h4>
                            <i>
                                <AssignmentInd className={classes.iocns} />{" "}
                            </i>{" "}
                            <span className="span12px">
                                {" "}
                                {trainer.trainer_Specialty}{" "}
                            </span>
                            <br></br>
                            <i>
                                <Schedule className={classes.iocns} />{" "}
                            </i>{" "}
                            <span className="span12px">
                                {" "}
                                {trainer.trainer_Active === true
                                    ? "متاح"
                                    : "غير متاح"}{" "}
                            </span>
                            <br></br>
                            {trainer.is_Trainer_Deleted === true ? (
                                <span
                                    className="span12px"
                                    style={{ color: "red", fontSize: "15px" }}
                                >
                                    "محذوف"{" "}
                                </span>
                            ) : null}
                            <br></br>
                            <p> {trainer.trainer_Describe} </p>
                            <label> {trainer.score_Value} ريال استشاره</label>
                            <br></br>
                            <button

                                onClick={() =>
                                    redirectToUrl(
                                        `/Admin/TrainerProfile?TrainerID=${trainer.trainer_Id}`
                                    )
                                }
                            >
                                تحديث
                            </button>
                            <button

                                onClick={() =>
                                    handleOpen_DialogContent_trainer_Rating(
                                        trainer.trainer_Id
                                    )
                                }
                            >
                                تعليقات المدرب
                            </button>
                            <button


                                onClick={() =>
                                    openfollowUp_Schedule(trainer.trainer_Id)
                                }
                            >
                                عرض الجدول الخاص للمدرب
                            </button>
                            <button
                                onClick={() =>
                                    redirectToUrl(
                                        `/Admin/Subscription_Schedule_Trainer?New=${trainer.trainer_Id}`
                                    )
                                }
                            >
                                اضافة جدول جديد للمدرب
                            </button>
                            <button


                                onClick={() =>
                                    redirectToUrl(
                                        `/Admin/InvoiceTrainer?TrainerID=${trainer.trainer_Id}`
                                    )
                                }
                            >
                                فاتوره المدرب
                            </button>
                            <button

                                onClick={() =>
                                    opne_CV(
                                        trainer.trainer_Image
                                    )
                                }
                            >
                                CV المدرب
                            </button>
                            <button

                                onClick={() =>
                                    handle_Open_DialogContentSubscriptionOffer(trainer.trainer_Id)
                                }
                            >
                                عروض المدرب
                            </button>


                            <button

                                style={{ backgroundColor: "red" }}

                                onClick={() => {
                                    if (window.confirm("هل متاكد انك تبغى تحدف  ؟؟"))
                                        Delete_trainer(trainer.trainer_Id);
                                }}
                            >
                                حذف المدرب
                            </button>
                        </div>
                    </div>

                    <hr></hr>
                </div>
            );
        })
    )


}














TrainerRow.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TrainerRow);
